import { animated } from "@react-spring/web";
import { useDrag } from "@use-gesture/react";
import React, {useRef } from "react";
import { ANNOTATOR_TOOL_DETAILS_HEIGHT } from "../tools/Contants";
import { Annotation } from "../objects/Annotation.interface";
import { Entity } from "../objects/Entity.interface";
import { Field } from "../objects/Field.interface";


export type ToolsProps = {
    AnnotationSelected:Annotation,
    TmpAnnotationSelected:Annotation,
    activeDragDetails: boolean,
    heightDetails: number,
    heightDetailsSaved:number,
    containerDetailsRef: HTMLDivElement | null,
    dropdownToolDetailsRef: HTMLButtonElement | null,
    setDetailsStatus: (activeDrag: boolean, height: number) => void,
    getEntityById: (entityId: number) => Entity|undefined,
    getFieldByCode: (field:string,entityId:number) => Field|undefined,
}

export default function ToolList (props: ToolsProps){
    const detailsContentRef = useRef<HTMLDivElement | null>(null);

    const setDetailsToolHeight = (height:number) =>{
                sessionStorage.setItem(ANNOTATOR_TOOL_DETAILS_HEIGHT, height.toString());
            }

    const bindHandleDetailsToolPosition = useDrag((params) => {
            
        if(props.dropdownToolDetailsRef != null){  
            const containerHeight = detailsContentRef.current?.clientHeight;
            
            

        
            props.setDetailsStatus(params.active, params.offset[1]);
            

            console.log('Tamano: ' + props.heightDetails + ' , Drag activo: '+ containerHeight!);


            if(containerHeight != undefined){
                
                setDetailsToolHeight(containerHeight);
            }
        }
    },{
        from: (event) =>{
            return [0,props.heightDetails];
        },
        bounds: (state) => {
            if(props.containerDetailsRef != null){
                const containerHeight = props.containerDetailsRef!.clientHeight ?? 0;
                const detailsHeight = containerHeight - props.heightDetails;
                return{
                    bottom: detailsHeight
                }
            }else
            {
                return{}
            }
            
        }
    });

    return(
    <animated.div ref={detailsContentRef} style={{ height: (props.activeDragDetails)?props.heightDetails:props.heightDetailsSaved}}  className="sub-container" {...bindHandleDetailsToolPosition() ?? {}}>                                        
        <div >
            <div className="area-details-data"><span className="area-details-data-title">Text:</span> {(props.AnnotationSelected.relatedTo == -1)?props.AnnotationSelected.text:props.AnnotationSelected.relatedText}</div>
            <div className="area-details-data"><span className="area-details-data-title">First Entity:</span> {props.getEntityById(props.TmpAnnotationSelected.firstEntityId)?.Entity}</div>
            <div className="area-details-data">&emsp; &emsp;<span className="area-details-data-title">First Field:</span> {(props.AnnotationSelected.fieldsFirstEntity!.length >= 1)?props.getFieldByCode(props.TmpAnnotationSelected.fieldsFirstEntity![0],props.TmpAnnotationSelected.firstEntityId)?.name:'undefined'}</div>
            <div className="area-details-data">&emsp; &emsp;<span className="area-details-data-title">Second Field:</span> {(props.AnnotationSelected.fieldsFirstEntity!.length >= 2)?props.getFieldByCode(props.TmpAnnotationSelected.fieldsFirstEntity![1],props.TmpAnnotationSelected.firstEntityId)?.name:'undefined'}</div>
            <div className="area-details-data"><span className="area-details-data-title">Second Entity:</span> {props.getEntityById(props.AnnotationSelected.secondEntityId)?.Entity}</div>
            <div className="area-details-data">&emsp; &emsp;<span className="area-details-data-title">First Field:</span> {(props.AnnotationSelected.fieldsSecondEntity!.length >= 1)?props.getFieldByCode(props.TmpAnnotationSelected.fieldsSecondEntity![0],props.TmpAnnotationSelected.secondEntityId)?.name:'undefined'}</div>
            <div className="area-details-data">&emsp; &emsp;<span className="area-details-data-title">Second Field:</span> {(props.AnnotationSelected.fieldsSecondEntity!.length >= 2)?props.getFieldByCode(props.TmpAnnotationSelected.fieldsSecondEntity![1],props.TmpAnnotationSelected.secondEntityId)?.name:'undefined'}</div>
        </div>
        <div className="tool-handle"></div>
    </animated.div>
    );
}